import {useEffect, useState} from 'react';
import {config} from '../environment';
import {GPSResponse} from '../types/vwCelebration';

type UseFetchVWCelebrationGPSProps = {
  event: string;
  keyword: string;
};

export const useFetchVWCelebrationGPS = ({
  event,
  keyword,
}: UseFetchVWCelebrationGPSProps) => {
  const [data, setData] = useState<GPSResponse>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!event || !keyword) {
      return;
    }

    const fetchData = async () => {
      try {
        const res = (await fetch(
          `${config.API_VW_CELEBRATION_GPS_DATA}?event=${event}&keyword=${keyword}`,
        ).then((res) => res.json())) as GPSResponse;

        setData(res);
      } catch (error) {
        console.error('Error fetching GPS data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [event, keyword]);

  return {data, loading};
};
